import { ExternalLink } from "lucide-react";

import { Button } from "@/shared/ui/button";

/** 「查看站点」/「打开」:已发布才是真链接;没发布 / 已归档上锁(与站点卡「发布后可预览」同口径)。 */
export function PreviewLink({
  href,
  blocked,
  label,
  solid,
}: {
  href: string;
  /** 点不开的原因;null = 真链接。 */
  blocked: string | null;
  label: string;
  solid?: boolean;
}) {
  const variant = solid ? "default" : "outline";
  if (blocked) {
    return (
      <Button type="button" size="sm" variant={variant} disabled title={blocked}>
        <ExternalLink />
        {label}
      </Button>
    );
  }
  return (
    <Button asChild size="sm" variant={variant}>
      <a href={href} target="_blank" rel="noopener noreferrer">
        <ExternalLink />
        {label}
      </a>
    </Button>
  );
}
